// @ts-nocheck
import { node } from "~/util/dom";
import createSDSIcon from "~/ui/icon";
import { PLUS_24 } from "@sznds/icons";
import { ICON_REMOVE_24 } from "~/ui/icons";

export default class ControlZoom extends SMap.Control.Visible {
	constructor(map) {
		super();
		this.setOwner(map);
		const zoomGroup = node("mapy-map-button-group", { className: "gallery-zoom" });
		const [minZoom, maxZoom] = this.getMap().getZoomRange();
		const zoom = this.getMap().getZoom();

		this._zoomOutButton = node("mapy-map-button");
		this._zoomOutButton.appendChild(createSDSIcon({ symbol: ICON_REMOVE_24 }));
		this._zoomOutButton.addEventListener("click", this, false);
		zoomGroup.appendChild(this._zoomOutButton);
		this._zoomInButton = node("mapy-map-button");
		this._zoomInButton.appendChild(createSDSIcon({ symbol: PLUS_24 }));
		this._zoomInButton.addEventListener("click", this, false);
		zoomGroup.appendChild(this._zoomInButton);
		this._zoomInButton.disabled = zoom === maxZoom;
		this._zoomOutButton.disabled = zoom === minZoom;
		this._node = zoomGroup;
	}

	destroy() {
		this._zoomInButton.removeEventListener("click", this, false);
		this._zoomOutButton.removeEventListener("click", this, false);
	}

	getContainer() {
		return this._node;
	}

	handleEvent(event: PointerEvent) {
		if (event.target === this._zoomInButton || event.target === this._zoomOutButton) {
			const map = this.getMap();
			const center = map.getCenter();
			const zoom = map.getZoom();
			const [minZoom, maxZoom] = map.getZoomRange();
			const newZoom = event.target === this._zoomInButton ? Math.min(zoom + 1, maxZoom) : Math.max(zoom - 1, minZoom);

			map.setCenterZoom(center, newZoom, true);
			this._zoomInButton.disabled = newZoom === maxZoom;
			this._zoomOutButton.disabled = newZoom === minZoom;
		}
	}

	// eslint-disable-next-line class-methods-use-this
	_build() {}
}
